<template>
  <div class="quantity">
    <button class="quantity__minus" @click="decrease">-</button>
    <input class="quantity__input" type="number" @change="validateQuantity" v-model="quantity" min="1" max="500" step="1">
    <button class="quantity__plus" @click="increase">+</button>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import errors                 from "@/components/mixins/errors";
import tools                  from "@/components/mixins/tools";
// import basket                 from "@/components/Basket/Basket.vue";

export default {
  props  : [
    "amount", "bid"
    // 'easy_clean'
  ],
  name   : "BasketButtons",
  mixins : [errors, tools],
  data()
  {
    return {
      quantity : 1
    };
  },
  watch    : {
    "amount"()
    {
      this.quantity = this.amount;
    }
  },
  methods  : {
    ...mapActions(["SET_QUANTITY"]),
    increase()
    {
      if(this.quantity > 499)
      {
        return;
      }
      this.quantity++;
      let context = this;
      this.debounce(function()
      {
        context.SET_QUANTITY(context, {
          bid      : context.bid,
          quantity : context.quantity,
          // easy_clean: context.easy_clean
        }).then(q => {
          if(q)
            context.quantity = q;
        });
      }, 1000);
    },
    decrease()
    {
      if(this.quantity < 2)
      {
        return;
      }
      this.quantity--;
      let context = this;
      this.debounce(function()
      {
        context.SET_QUANTITY(context, {
          bid      : context.bid,
          quantity : context.quantity
          // easy_clean: context.easy_clean
        });
      }, 1000);
    },
    validateQuantity( event )
    {
      if(isNaN(parseInt(event.target.value)))
      {
        event.target.value = 1;
        return;
      }
      this.quantity
                         = parseInt(event.target.value) > 0 && parseInt(event.target.value) <= 500 ? parseInt(event.target.value) : 1;
      event.target.value = this.quantity;
      this.SET_QUANTITY({
        bid      : this.bid,
        quantity : this.quantity
        // easy_clean: this.easy_clean
      }).then(q => {
        this.quantity = q;
      });
    }
  },
  computed :
      {
        ...mapState([
          "moduleBasket"
        ])
      },
  created()
  {
    this.quantity = this.amount;
  }
};
</script>

<style scoped>

</style>